import axios from '../index';
import { PaginationRequest, PaginationResult, ResponseResult, Url } from "../Common/Util";
import { InventoryItem } from "./Entities/InventoryEntities";

const GetUrl = Url("api/v1/Inventory/InventoryItems");

export default {
    FindProtocolInventory,
    FindPharmacyInventory,
    FindLaboratoryKitInventory,
    GetById,
    CreateProtocol,
    UpdateProtocol
};

async function FindProtocolInventory({ search, includeStock, includeLastEntry, pageNumber, sortColumn, sortOrder, pageSize = 10, protocolId = null, includedTypes = null } = {}) {
    const response = await axios.get(GetUrl("/Protocol"), {
        params: {
            search, includeStock, includeLastEntry, pageNumber, sortColumn, sortOrder, pageSize, protocolId, includedTypes
        }
    });
    return new PaginationResult(response.data);
}

async function FindPharmacyInventory({ search, includeStock, includeLastEntry, pageNumber, sortColumn, sortOrder, pageSize = 10 } = {}) {
    const response = await axios.get(GetUrl("/Pharmacy"), {
        params: {
            search, includeStock, includeLastEntry, pageNumber, sortColumn, sortOrder, pageSize
        }
    });
    return new PaginationResult(response.data);
}

async function FindLaboratoryKitInventory({ search, includeStock, includeLastEntry, pageNumber, sortColumn, sortOrder, pageSize = 10 } = {}) {
    const response = await axios.get(GetUrl("/LaboratoryKit"), {
        params: {
            search, includeStock, includeLastEntry, pageNumber, sortColumn, sortOrder, pageSize
        }
    });
    return new PaginationResult(response.data);
}

async function GetById({ itemId, includeStock, includeLastEntry, assignmentType } = {}) {
    if (isNaN(itemId) || itemId < 1) throw new Error('The ID is invalid');
    const response = await axios.get(GetUrl(""), {
        params: {
            itemId, includeStock, includeLastEntry, assignmentType
        }
    });
    return new ResponseResult(response.data);
}

async function CreateProtocol({ protocolId, name, medicationForm, kitQuantity }) {
    const response = await axios.post(GetUrl("/Protocol"), { protocolId, name, medicationForm, kitQuantity });
    return new ResponseResult(response.data);
}

async function UpdateProtocol({ itemId, name, medicationForm, kitQuantity }) {
    const response = await axios.put(GetUrl("/Protocol"), { itemId, name, medicationForm, kitQuantity });
    return new ResponseResult(response.data);
}



